import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IMember, IUser } from '@interfaces';
import { ApplicationHttpClient } from './../http-client';
import { UserService } from '@base/user/user.service';

@Injectable()
export class MemberService {
  constructor(
    private http: ApplicationHttpClient,
    private userService: UserService,
  ) { }

  delete(member: IMember): Observable<any> {
    const user: IUser = {...member.user};
    const groupId = member.group_id;
    const auxListMemberships = [...user.memberships];
    const objIndex = auxListMemberships.findIndex((item) => item['group']['id'] === groupId);
    if (objIndex >= 0) {
      const groupDeleted = auxListMemberships.splice(objIndex, 1);
      user.memberships = auxListMemberships;
      this.userService.updateUser(user);
    }
    return this.http.Delete(`members/${member.id}/`);
  }

  private updateUserInfo(membership: IMember) {
    const user: IUser = {...membership.user};
    const groupId = membership.group_id;
    const status = membership.active;
    const auxListMemberships = [...user.memberships];

    const objIndex = auxListMemberships.findIndex((item) => item['group']['id'] === groupId);
    if (objIndex >= 0) {
      auxListMemberships[objIndex]['active'] = status;
      user.memberships = auxListMemberships;

      this.userService.updateUser(user);
    }
  }

  switchStatus(membership: IMember): Observable<any> {
    const payload = {
      id: membership.id,
      active: membership.active,
      group: membership.group_id,
      user: membership.user.id,
    };
    this.updateUserInfo(membership);

    return this.http.Put(`members/${payload.id}/`, payload);
  }
}
